const areSameInsurance = (serverLineItem, draftLineItem) => {
  if (draftLineItem.type !== "insurance" || serverLineItem.typeDetails?.__typename !== "BundlePrescriptionGlassesTypeDetails") {
    return false;
  }
  return serverLineItem.insurance?.sku === draftLineItem.sku && serverLineItem.id === draftLineItem.typeDetails?.lineItemId;
};
export {
  areSameInsurance
};
//# sourceMappingURL=are-same-insurance.js.map
